const APP_STAGE = "PROD";

const LOCAL_URL = "http://localhost:3000/prod/";
const SERVER_URL = "https://api.bloomnloomspeechtherapy.com/";

const BASE_URL = APP_STAGE === "LOCAL" ? LOCAL_URL : SERVER_URL;

const CLIENT_URL = `${BASE_URL}client`;
const PRACTITONERS_URL = `${BASE_URL}client/practitioners`;
const IMAGEUPLOAD_URL = `${BASE_URL}admin/asset`;
const INTAKEFORM_URL = `${BASE_URL}client/intake-form`;
const CUST_PORTAL_API_KEY = "bnl-free-apikeyforwebapp";
const APPOINTMENTS_URL = `${BASE_URL}client/appointments`;
const LOGIN_URL =
  "https://auth.bloomnloomspeechtherapy.com/oauth2/authorize?client_id=48s46is29rdvipf4cdudda8ij2&response_type=code&scope=email+openid+phone&redirect_uri=http%3A%2F%2Flocalhost%3A3001";

const SIGNIN_URL =
  APP_STAGE === "PROD"
    ? "https://auth.bloomnloomspeechtherapy.com/"
    : "http://localhost:3005";

const COGNITO_CONFIG_LOCAL = {
  REGION: "ca-central-1",
  USER_POOL_ID: "ca-central-1_BkDY8YNhq",
  APP_CLIENT_ID: "o95jt607ru17hp7rfnp5p02cj",
  DOMAIN: "bloomnloomspeechtherapy.com",
  SCOPE: ["email", "openid", "phone"],
  REDIRECT_SIGN_IN: "http://localhost:3003",
  REDIRECT_SIGN_OUT: "http://localhost:3003/login",
  RESPONSE_TYPE: "code",
  SECRET_HASH: "",
};

const COGNITO_CONFIG_SERVER = {
  REGION: "ca-central-1",
  USER_POOL_ID: "ca-central-1_BkDY8YNhq",
  APP_CLIENT_ID: "o95jt607ru17hp7rfnp5p02cj",
  DOMAIN: "bloomnloomspeechtherapy.com",
  SCOPE: ["email", "openid", "phone"],
  REDIRECT_SIGN_IN: "https://customer.bloomnloomspeechtherapy.com/",
  REDIRECT_SIGN_OUT: "https://customer.bloomnloomspeechtherapy.com/login",
  RESPONSE_TYPE: "code",
  SECRET_HASH: "",
};

export const APP_CONFIG = {
  BASE_URL,
  CLIENT_URL,
  INTAKEFORM_URL,
  CUST_PORTAL_API_KEY,
  SIGNIN_URL,
  APPOINTMENTS_URL,
  PRACTITONERS_URL,
  IMAGEUPLOAD_URL
};
export const COGNITO_CONFIG =
  APP_STAGE === "LOCAL" ? COGNITO_CONFIG_LOCAL : COGNITO_CONFIG_SERVER;
